import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MatchLayout from 'Views/Page/Content/Modal/Layouts/RetirementPlanMatch/MatchLayout';
import RetirementPlanMatchOverrideSet from 'Views/Page/Content/Modal/Layouts/RetirementPlanMatch/MetaOverrideSet';
import Typography from 'Components/UI/Typography';

const RulesForm = withStyles(theme => ({
  root: {
    padding: 0,
    margin: 0,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
}))(MetaCollectionFormInline);

const styles = theme => ({
  root: {
  },
  content: {
    width: '100%',
  },
  continueButton: {
    padding: theme.spacing(1),
  },
  stepNavigationContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: theme.spacing(3),
  },
  form: {
    padding: 0,
  },
  help: {
    padding: theme.spacing(0, 2, 2, 2),
  },
});

const MAX_NUM_MATCHES = 3;

const RetirementPlanMatch = ({
  className,
  classes,
}) => {
  const { resource, handleChange } = useMetaLayoutContext();
  const matchRulesCollection = resource.attr('matchingRules');
  const numMatchingRules = matchRulesCollection.resources().length();
  const isReadonly = matchRulesCollection
    .resources()
    .head()
    .meta()
    .field('employerMatchLevelPercentage')
    .attr('readonly');

  const onAdd = () => {
    handleChange('matchingRules', resource.attr('matchingRules').create({
      addToCollection: true,
    }));
  };

  const onRemove = (i) => {
    resource.attr('matchingRules').resources().removeItemByIndex(i);
    handleChange('matchingRules', resource.attr('matchingRules'));
  };

  // Add a rule by default if there aren't any
  useEffect(() => {
    if (numMatchingRules === 0) {
      onAdd();
    }
  }, [numMatchingRules]);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography align="center" variant="body1" className={classes.help}>
        Using the inputs below, provide how much the employer will match based on the employee contribution. e.g. Employer matches 100% of contribution up to 4%
      </Typography>
      <MetaControlField
        attr={'selectedIncome'}
      />
      {resource.attr('matchingRules') && <RulesForm
        title="Rules"
        collection={resource.attr('matchingRules')}
        metaOverrideSet={RetirementPlanMatchOverrideSet}
        addButtonText={'Add New Rule'}
        AddButtonProps={{
          disabled: isReadonly || numMatchingRules >= MAX_NUM_MATCHES,
        }}
        FormProps={{
          layout: MatchLayout,
          noIndividualSubmitButtons: true,
          classes: {
            root: classes.form,
          },
          LayoutProps: {
            isRemovable: !isReadonly && numMatchingRules > 1,
            onRemove,
          },
        }}
        onAdd={onAdd}
      />}
    </Box>
  );
};

RetirementPlanMatch.defaultProps = {
  className: '',
};

RetirementPlanMatch.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RetirementPlanMatch);
